export default (givenName: string, familyName: string): string => `${givenName.trim()[0]}${familyName.trim()[0]}`.toUpperCase();